import { render, staticRenderFns } from "./changeWarehouse.vue?vue&type=template&id=5cb55d28&scoped=true"
import script from "./changeWarehouse.vue?vue&type=script&lang=js"
export * from "./changeWarehouse.vue?vue&type=script&lang=js"
import style0 from "./changeWarehouse.vue?vue&type=style&index=0&id=5cb55d28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb55d28",
  null
  
)

export default component.exports